import Select from "react-select";
import { MultiCompanySelector } from "../../../components/CompanySelector/index.jsx";
import {
  compactSelectStyles,
  multiCompanySelectStyles,
} from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";
import { formatBuyerUserOption } from "./reportFilterFormatters.js";

const B2bAttendanceReportPanel = ({
  t,
  reportI18nKeys,
  b2bEventsOptions,
  selectedB2bEvent,
  selectedReportOption,
  loadingB2bEvents,
  b2bBuyerCompaniesOptions,
  selectedB2bBuyerCompanies,
  loadingBuyerCompanies,
  b2bBuyerUsersOptions,
  selectedB2bBuyerUser,
  setSelectedB2bBuyerUser,
  onSelectB2bBuyerCompanies,
  businessEventSelectProps,
  handlers,
}) => (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.EVENT)}</label>
      <Select
        options={b2bEventsOptions}
        value={selectedB2bEvent}
        onChange={handlers.onSelectEvent}
        isClearable
        isDisabled={!selectedReportOption}
        isLoading={loadingB2bEvents}
        placeholder={t(reportI18nKeys.EVENT_PLACEHOLDER)}
        styles={compactSelectStyles}
        {...businessEventSelectProps}
      />
    </div>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.COMPANY)}</label>
      <MultiCompanySelector
        companies={b2bBuyerCompaniesOptions}
        selectedCompanies={selectedB2bBuyerCompanies}
        loading={loadingBuyerCompanies}
        isDisabled={!selectedReportOption}
        placeholder={t(reportI18nKeys.COMPANY_PLACEHOLDER)}
        styles={multiCompanySelectStyles}
        onChange={onSelectB2bBuyerCompanies}
      />
    </div>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t("pages.reports.buyerExecutive")}</label>
      <Select
        options={b2bBuyerUsersOptions}
        value={selectedB2bBuyerUser}
        onChange={setSelectedB2bBuyerUser}
        isClearable
        isDisabled={!selectedReportOption || !selectedB2bBuyerCompanies}
        placeholder={t("pages.reports.buyerExecutivePlaceholder")}
        styles={compactSelectStyles}
        getOptionLabel={formatBuyerUserOption}
      />
    </div>
  </ReportFilterSection>
);

export default B2bAttendanceReportPanel;
